import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { launchTrustConfigured } from "@/features/identity/useLaunchTrustRegistration";

export type LaunchTrustFieldsValue = {
  trustEnabled: boolean;
  founderEntityId: string;
  entityMetadataURI: string;
  projectMetadataURI: string;
};

export function LaunchTrustFields({
  value,
  onChange,
  entityLabel = "Founder",
}: {
  value: LaunchTrustFieldsValue;
  onChange: (next: LaunchTrustFieldsValue) => void;
  entityLabel?: string;
}) {
  return (
    <div className="space-y-4 rounded-lg border p-4">
      <div className="flex items-start gap-3">
        <Checkbox
          id="trustEnabled"
          checked={value.trustEnabled}
          disabled={!launchTrustConfigured}
          onCheckedChange={(checked) => onChange({ ...value, trustEnabled: checked === true })}
        />
        <div>
          <Label htmlFor="trustEnabled">Register this as a trust-backed project</Label>
          <p className="mt-1 text-xs text-muted-foreground">
            {launchTrustConfigured
              ? "Registers the controlling entity and project before deployment, then binds the deployed asset on Polygon."
              : "Trust registries are not configured in this deployment; standard creation remains available."}
          </p>
        </div>
      </div>
      {value.trustEnabled && (
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="space-y-2">
            <Label htmlFor="founderEntityId">Existing {entityLabel.toLowerCase()} entity ID (optional)</Label>
            <Input id="founderEntityId" inputMode="numeric" value={value.founderEntityId} onChange={(event) => onChange({ ...value, founderEntityId: event.target.value })} placeholder="Leave blank to register one" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="entityMetadataURI">{entityLabel} metadata URI</Label>
            <Input id="entityMetadataURI" value={value.entityMetadataURI} disabled={Boolean(value.founderEntityId)} onChange={(event) => onChange({ ...value, entityMetadataURI: event.target.value })} placeholder="ipfs://..." />
          </div>
          <div className="space-y-2 sm:col-span-2">
            <Label htmlFor="projectMetadataURI">Project metadata URI</Label>
            <Input id="projectMetadataURI" value={value.projectMetadataURI} onChange={(event) => onChange({ ...value, projectMetadataURI: event.target.value })} placeholder="ipfs://..." />
          </div>
        </div>
      )}
    </div>
  );
}
